import { IPaymentCompletedResponse } from "../payments.typings";

export const swipedState = {
	swipedPay: {
		applyStateLoading: {
			errorMessage: "",
			hasError: false,
			loading: false,
			started: false,
			success: false,
		},
		paymentResponse: {} as IPaymentCompletedResponse,
	},
};

const swipedPayReducer = () => {
	return {
		postSwipedPayStart: (state, { payload }) => {
			return {
				...state,
				swipedPay: {
					...state.swipedPay,
					applyStateLoading: {
						started: true,
						loading: true,
						success: false,
						hasError: false,
						errorMessage: "",
					},
				},
			};
		},
		postSwipedPayComplete: (state, { payload }) => {
			return {
				...state,
				swipedPay: {
					...state.swipedPay,
					applyStateLoading: {
						...state.swipedPay.applyStateLoading,
						started: true,
						loading: false,
						success: true,
					},
					paymentResponse: payload.data.results,
				},
			};
		},
		postSwipedPayFail: (state, { payload }) => {
			return {
				...state,
				swipedPay: {
					...state.swipedPay,
					applyStateLoading: {
						...state.swipedPay.applyStateLoading,
						started: true,
						loading: false,
						success: false,
						hasError: true,
						errorMessage: payload,
					},
				},
			};
		},
		resetSwipedPaymentState: (state) => {
			return {
				...state,
				swipedPay: {
					applyStateLoading: {
						started: false,
						loading: false,
						success: false,
						hasError: false,
						errorMessage: "",
					},
					paymentResponse: {} as IPaymentCompletedResponse,
				},
			};
		},
	};
};
export default swipedPayReducer;
